export default __webpack_public_path__ + "static/request-for-quotations-fabric-view-0105c674052a1e41c7deee5392b48432.png";